module.exports = __webpack_public_path__ + "img/bmw-300x139.691af5e5.png";